import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const Container = superstyled({
  name: 'TwoColumnLayout',
  slot: 'Container',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(3),
    justifyContent: 'space-around',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: theme.spacing(6)
    },
    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(10)
    }
  })
});

export const SmallColumn = superstyled({
  name: 'TwoColumnLayout',
  slot: 'SmallColumn',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(3),
    flexBasis: '100%',
    flexShrink: 0,

    [theme.breakpoints.up('md')]: {
      flexBasis: '45%',
      maxWidth: 480
    }
  })
});

export const LargeColumn = superstyled({
  name: 'TwoColumnLayout',
  slot: 'LargeColumn',
  styles: ({ theme }) => ({
    flexBasis: '100%',
    maxWidth: '100%',

    [theme.breakpoints.up('md')]: {
      paddingBlockStart: theme.spacing(6), // 48px
      maxWidth: 420
    },

    [theme.breakpoints.up('lg')]: {
      paddingInline: theme.spacing(5.75), // 46px
      maxWidth: '100%'
    }
  })
});
